export const NOTIFICATION_POST = 'NOTIFICATION_POST';
export const NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';
